export default __webpack_public_path__ + "static/media/management.319c7733.svg";